/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



// src/pages/AccountsPage.tsx
import React from "react";
import AccountingsDataContent from "components/content/AccountingDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * Accounting and financial management page.
 * 
 * Features:
 * - Financial transaction ledger
 * - Account balance summaries
 * - Payment processing and tracking
 * - Revenue reports and analytics
 * - Outstanding balance management
 * - Transaction filtering by date, type, account
 * - Integration with billing encounters and claims
 * 
 * @returns Accounting page component
 */
const AccountingsPage: React.FC = () => {
  return (
    <DefaultDashboardLayout>
      <AccountingsDataContent />
    </DefaultDashboardLayout>
  );
};

export default AccountingsPage;

